import axios from 'axios';
import { getApiUrl } from '../../../config';

export const getCharges = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/charges`,
        withCredentials: true,
        crossorigin: true
    });
}

export const getCharge = (id) => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/charges/${id}`,
        withCredentials: true,
        crossorigin: true
    });
}

export const createCharge = (charge) => {
    return axios.request({
        method: 'POST',
        url: `${getApiUrl()}/billing/charges`,
        data: charge,
        withCredentials: true,
        crossorigin: true
    });
}

export const updateCharge = (id, charge) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/charges/${id}`,
        data: charge,
        withCredentials: true,
        crossorigin: true
    });
}

export const deleteCharge = (id) => {
    return axios.request({
        method: 'DELETE',
        url: `${getApiUrl()}/billing/charges/${id}`,
        withCredentials: true,
        crossorigin: true
    }); 
}

export const activateCharge = (id) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/charges/${id}/activate`,
        withCredentials: true,
        crossorigin: true
    });
}

export const deactivateCharge = (id) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/charges/${id}/deactivate`,
        withCredentials: true,
        crossorigin: true
    });
}